import type React from 'react';

export function formatChatCredits(n: number): string {
  const rounded = Math.round(n * 100) / 100;
  return rounded.toLocaleString('pt-BR', {
    minimumFractionDigits: Number.isInteger(rounded) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

export const creditChip: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: 999,
  background: 'rgba(255,255,255,0.08)',
  border: '1px solid rgba(255,255,255,0.1)',
  fontSize: '0.58rem',
  fontWeight: 600,
  color: 'rgba(255,255,255,0.72)',
  letterSpacing: '0.01em',
};

export const generationCreditChip: React.CSSProperties = {
  ...creditChip,
  background: 'rgba(99,102,241,0.22)',
  borderColor: 'rgba(129,140,248,0.35)',
};
